'use strict';

$(document).ready(function () {
    $(window).on('scroll', function () {
        if ($(window).width() >= 1024) {
            var visibleHeaderHeight = $('header')[0].getBoundingClientRect().bottom;
            var buyNowBtn = $('.add-buy-now')[0];
            var addToCartBtnDiamond = $('.add-to-cart-diamond')[0] || $('.go-to-cart-btn')[0];

            if (buyNowBtn) {
                var buyNowBtnBottom = buyNowBtn.getBoundingClientRect().bottom;

                if (buyNowBtnBottom <= visibleHeaderHeight) {
                    $('.sticky-row').addClass('show');
                    $('.stone-fact-desktop').addClass('push-up');
                } else {
                    $('.sticky-row').removeClass('show');
                    $('.stone-fact-desktop').removeClass('push-up');
                }
            }

            if (addToCartBtnDiamond) {
                var addToCartBtnBottom = addToCartBtnDiamond.getBoundingClientRect().bottom;
                if (addToCartBtnBottom <= visibleHeaderHeight) {
                    $('.custom-sticky-row').addClass('show');
                } else {
                    $('.custom-sticky-row').removeClass('show');
                }
            }
        }
    });
    var params = new URLSearchParams(window.location.search);
    var isCustomizable = params.get('isCustomizable');
    if (isCustomizable && isCustomizable === 'true') {
        $('.sticky-row').addClass('d-none');
        $('.try-at-wrapper').removeClass('d-flex').addClass('d-none');
        $('.delivery-return-accordian').addClass('d-none');
        $('.product-availability').addClass('d-none');
        $('.pdp-enquire-section').addClass('d-none');
    } else {
        $('.sticky-row').removeClass('d-none');
        $('.try-at-wrapper').removeClass('d-none').addClass('d-flex');
        $('.delivery-return-accordian').removeClass('d-none');
        $('.product-availability').removeClass('d-none');
        $('.pdp-enquire-section').removeClass('d-none');
    }

    if ($('.prices-add-to-cart-actions .add-to-cart').is(':disabled')) {
        $('.sticky-row').addClass('d-none');
        $('.custom-sticky-row').addClass('d-none');
    }
});

$(document).on('click', '.addtocart', function () {
    $('.add-to-bag').trigger('click');
});

$(document).on('click', '.diamond-pdp-addtocart', function () {
    $('.add-to-cart-diamond').trigger('click');
});

$(document).on('click', '.diamond-buynow-button', function () {
    $('.add-diamond-buy-now').trigger('click');
});

$(document).on('click', '.buynow-button', function () {
    $('.add-buy-now').trigger('click');
});

$(document).on('click', '.seebag', function () {
    $('.see-bag-gray').trigger('click');
});
